<template>
	<nk-multichoice v-model="value" @update:modelValue="valueChanged" :data="dropdownData" :options="componentOptions" :tabindex="tabindex" ref="multichoice"></nk-multichoice>
</template>
<script>
	import _ from 'lodash'
	import $ from 'jquery'
	import Table from '~/components/table/grid'
	import FloatingCenterAdvanceName from '~/components/form/floating-center-advance-name'
	import { mapGetters, mapActions } from 'vuex'
	import emptyId from '~/statics/empty-id'
	import Endpoints from '@nikan/endpoints'

	export default {
		props: {
			modelValue: {},
			options: {},
			tabindex: {}
		},
		emits: ['update:modelValue', 'dataChanged'],
		data() {
			return {
				settings: {
					baseUrl: Endpoints.getUrl('floatingCenters.search'),
					baseAccountId: 0,
					cleanOnMount: true,
					editable: true,
					display: (item) => {
						if (item != null) {
							return `<span class="code">${item.accountingCode}</span> ${item.name}`
						}

						return ''
					},
					readOnlyDisplay: (item) => {
						return `<span class="code">${item.accountingCode}</span> ${item.name}`
					},
					searchRequestFilter: (items, request) => {
						var ids = []
						if (items && items.length > 0) {
							for (var i = 0; i < items.length; i++) {
								ids.tryPush(items[i].position)
							}

							request.exceptPositions = ids
							request.relatedAccountId = this.baseAccountsArray[0]
						}

						return request
					},
					dropdown: {
						url: null,
						remoteSearch: false,
						loadOnMount: false,
						searchableFields: ['accountingCode', 'name'],
						placeholder: this.$t('search'),
						display: (item) => `${item.accountingCode} - ${item.name}`,
						findExactMatch: this.findExactMatch,
						selectorWidth: '400px',
						component: {
							type: Table,
							options: {
								searchable: false,
								editable: false,
								activeRowDisabled: true,
								columns: [
									{
										name: 'accountingCode',
										title: 'کد',
										width: '50px',
										pinnable: false,
										resizable: false
									},
									{
										name: 'name',
										title: 'نام',
										view: (row, col) => {
											return {
												component: FloatingCenterAdvanceName,
												options: {
													advance: true,
													data: row,
													factorType: this.factorType
												}
											}
										},
										width: 'auto|>250px',
										pinnable: false,
										resizable: false
									}
								]
							}
						}
					}
				},
				centersList: [],
				ready: false
			}
		},
		computed: {
			...mapGetters({
				findForm: 'forms/findFormByKey',
				getAutoAccountsItemsByKey: 'autoAccounts/getItemsByKey',
				getCentersByAccountId: 'floatingCenters/getCentersByAccountId',
				getAllCenters: 'floatingCenters/all'
			}),
			componentOptions() {
				var sett = _.cloneDeep(this.settings)

				var url = sett.baseUrl

				sett.dropdown.url = url

				if (!sett.editable) {
					sett.display = sett.readOnlyDisplay
				}

				return sett
			},
			dropdownData() {
				let result = (() => {
					let data = this.centersList

					if (data.length === 0) {
						return data
					} else if ((this.modelValue || []).length > 0) {
						return this.modelValue.reduce((list, current) => {
							return list.filter(x => x.position !== current.position)
						}, data)
					} else {
						return data
					}
				})()

				result = result.filter(x => x.hasChild === false)

				this.$emit('dataChanged', result)
				return result
			},
			baseAccountsArray() {
				if (this.settings.formName && this.findForm(this.settings.formName)) {
					let keys = this.findForm(this.settings.formName)
						.types
						.reduce((arr, item) => {
							arr.push(item.key)
							return arr
						}, [])
					this.settings.baseAccountId = this.findAccountsByAutoKey(keys)
				}

				if (!this.settings.baseAccountId) {
					return []
				} else if (Array.isArray(this.settings.baseAccountId)) {
					return this.settings.baseAccountId
				} else if (this.settings.baseAccountId > emptyId) {
					return [this.settings.baseAccountId]
				} else {
					return []
				}
			},
			factorType() {
				return this.settings.factorType || ''
			}
		},
		watch: {
			options: {
				deep: true,
				immediate: true,
				handler(val) {
					this.settings = _.merge({}, this.settings, val)
					this.prepareCentersList()
				}
			},
			getAllCenters: {
				deep: true,
				handler() {
					this.prepareCentersList()
				}
			},
			centersList: {
				handler() {
					this.cleanValue()
				}
			}
		},
		created() {
		},
		mounted() {
			if (this.settings.cleanOnMount)
				this.cleanValue()
		},
		methods: {
			...mapActions('floatingCenters', {
				getCentersByAccountIdAndItsParents: 'getCentersByAccountIdAndItsParents'
			}),
			findAccountsByAutoKey(keys) {
				let accounts = []
				if (!keys)
					return accounts

				for (let key of keys) {
					accounts.push(...this.getAutoAccountsItemsByKey(key))
				}

				accounts = accounts.reduce((list, current) => {
					if (list.findIndex(x => x.id === current.id) === -1) {
						list.push(current)
					}

					return list
				}, [])

				return accounts.map(x => x.id)
			},
			prepareCentersList() {
				if (this.settings.formName && this.baseAccountsArray.length === 0)
					this.centersList = []
				else if (this.baseAccountsArray.length > 0) {
					let promiseList = []
					for (let id of this.baseAccountsArray) {
						promiseList.push(this.getCentersByAccountIdAndItsParents({ accountId: id, centerLevel: this.settings.centerLevel }))
					}

					Promise.all(promiseList)
						.then(values => {
							let list = []
							for (let arr of values) {
								for (let item of arr) {
									if (list.findIndex(x => x.id === item.id) === -1 && item.hasChild === false) {
										list.push(item)
									}
								}
							}

							this.centersList = list
						})
				} else {
					this.centersList = this.getAllCenters
				}
			},
			cleanValue() {
				if (this.modelValue && this.modelValue.length > 0) {
					let cleanedValue = this.modelValue.filter(v => this.centersList.filter(x => x.id === v.id).length > 0)
					if (this.modelValue.length !== cleanedValue.length) {
						this.$emit('update:modelValue', cleanedValue)
					}
				}
			},
			valueChanged(val) {
				this.$emit('update:modelValue', val)
			},
			findExactMatch(list, text) {
				var filtered = list.filter(x => x.accountingCode === text)
				if (filtered.length === 1) {
					return filtered[0]
				}
			}
		},
	}
</script>
